import { ThemeModule } from "./theme.types";
import { biaisConfirmationTheme } from "./biaisConfirmation.theme";
import { attentionSelectiveTheme } from "./attentionSelective.theme";
import { voirNestPasToujoursCroireTheme } from "./voirNestPasToujoursCroire.theme";

// Référentiel central des thèmes disponibles (utilisé par les pages Comprendre/Pratiquer/Explorer).
export const allThemes: ThemeModule[] = [
  biaisConfirmationTheme,
  attentionSelectiveTheme,
  voirNestPasToujoursCroireTheme,
];

export {
  biaisConfirmationTheme,
  attentionSelectiveTheme,
  voirNestPasToujoursCroireTheme,
};
